export default class TravelDocument {
  static fromJSON(json) {
    return new TravelDocument(json)
  }

  constructor(json) {
    this.type = json.type || ''
    this.number = json.number || ''
    this.expirationDate = json.expirationDate || ''
    this.nationality = json.nationality || ''
    this.issueDate = json.issueDate || ''
    this.consentShow = json.consentShow || false
  }
}
